import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { useParams } from 'react-router-dom'; 
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import { Dialog, DialogContent, DialogActions, FormControl, FormLabel, Button,} from '@mui/material';
import Loading from '../components/Loading';

const SmartDiscounts = () => {
  const { listingId } = useParams();
  const [listing, setListing] = useState([]);
  const [listingData, setListingData] = useState([]);
  const [offerList, setOfferList] = useState([]);
  const [question, setQuestion] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedRangeId, setSelectedRangeId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [genericDialogOpen, setGenericDialogOpen] = useState(false);
  const [genericInputValue, setGenericInputValue] = useState('');
  const [genericOfferText, setGenericOfferText] = useState('');
  const [selectedGenericOffer, setSelectedGenericOffer] = useState(null);
  const [offerImage, setOfferImage] = useState('');

  useEffect(() => {
    const fetchListingData = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);
        formData.append('listing_id', listingId);

        try {
        const response = await axios({
            method: 'post',
            headers: {
            'Content-Type': 'multipart/form-data',
            },
            url: `${params.baseURL}${params.endpoints.getListingData}`,
            data: formData,
        });

        if (response.data.status === 'ok') {
            const listingData = response.data.updated_property_item;
            const { appr_list, resrv_list, offers, place_options_list } = listingData;
            setListing(response.data.updated_property_item);
            setListingData({ appr_list, resrv_list, offers, place_options_list });
            setQuestion(response.data.updated_property_item.questions);
            setOfferList(offers || []);
            setLoading(false);
        } else {
            toast.error('An error occurred while fetching data.');
            setLoading(false);
        }
        } catch (err) {
            console.log(err.message);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    fetchListingData();
    }, [listingId]);

    const saveListing = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        const listing_id = listingId;
        const ts = Date.now();
        const updatedPropertyItem = {
            offers: offerList
        };
        const mergedData = { ...listingData, ...updatedPropertyItem };

        let catData = new FormData();
        catData.append('token', hostData.host_access_token);
        catData.append('listing_id', listing_id);
        catData.append('data', JSON.stringify(mergedData));
        catData.append('ts', ts);

        try {
        const response = await axios({
            method: 'post',
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            },
            url: `${params.baseURL}${params.endpoints.updateListing}`,
            data: catData,
        });

        if (response.data.status === 'done') {
            toast.success('Discount Updated Successfully.')
        } else {
            toast.error('Failed to save data');
        }
        } catch (err) {
        toast.error('An error occurred while saving the listing');
        }
    };

  const openDrawerIfNeeded = (offer) => {
    if (offer.type === '7') {
      setSelectedOffer(offer);
      setSelectedRangeId(offer.selected_range_id || null);
      setDrawerOpen(true);
    }
  };

  const handleCheckboxChange = (id) => {
    setOfferList((prevOfferList) =>
      prevOfferList.map((offer) => {
        if (offer.id === id) {
          const newChecked = !offer.checked;
          const updatedOffer = { ...offer, checked: newChecked };

          if (newChecked) {
            if (offer.type === '7') {
              openDrawerIfNeeded(updatedOffer);
            } else {
              setSelectedGenericOffer(updatedOffer);
              setGenericOfferText(updatedOffer.title);
              setOfferImage(updatedOffer.offer_img);
              setGenericInputValue(updatedOffer.given_discount || '');
              setGenericDialogOpen(true);
            }
          }

          return updatedOffer;
        }
        return offer;
      })
    );
  };

  /*const handleCheckboxChange = (id) => {
    setOfferList((prevOfferList) =>
      prevOfferList.map((offer) => {
        if (offer.id === id) {
          const newChecked = !offer.checked;
          const updatedOffer = { ...offer, checked: newChecked };
          if (newChecked) openDrawerIfNeeded(updatedOffer);
          return updatedOffer;
        }
        return offer;
      })
    );
  };*/

  const handleInputChange = (id, value) => {
    setOfferList((prevOfferList) =>
      prevOfferList.map((offer) =>
        offer.id === id ? { ...offer, given_discount: value } : offer
      )
    );
  };

  const handleCardClick = (offer) => {
    if (offer.checked && offer.type === '7') {
      setSelectedOffer(offer);
      setSelectedRangeId(offer.selected_range_id || null);
      setDrawerOpen(true);
    }
  };

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loading />
    );
  }

  return (
    <>
      <div>
        <div className='row'>

          <div className='col-md-8'>
            <div className='ws-cl-header' style={{padding:'0 12px'}}>
              <div>
                <h4 className='ws-title'>Customise your Offer</h4>
              </div>
            </div>

            <div className='st1-desc-box'>
              <div className='row'>
                <div className='col-md-12 mb-4'>
                    <div className='pltxt-box'>
                        <div className='cat-pointer mb-0'>
                            <img src={listing.property_title_icon_image}  alt="Profile" className="pointer-icon" />
                            <div className='wspl-ta-section'>
                                <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                <span className='wspl-add-box'>{listing.property_address}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {offerList.length > 0 ? (
                  offerList.map((option) => (
                    <div
                      key={option.id}
                      className='col-md-6 lb mb-3'
                      onClick={() => handleCardClick(option)}
                      style={{ cursor: 'pointer' }}
                    >
                      <label className='radio-check-label'>
                        <span className='rcblss'>
                          <div className='ofsitdb' style={{borderBottom: '2px solid #ccc'}}>
                            <div style={{width: '25%', paddingRight:'10px'}}>
                              <img
                                src={option.offer_icon || '/assets/img/icons/smart_offer_icon.svg'}
                                alt={option.title || 'Untitled Listing'}
                                className='img-fluid smart-offer-icon'
                              />
                            </div>
                            <div className='dbds' style={{ width: '65%', marginLeft:'auto', textAlign:'end' }}>
                              <div className='dbpt'>
                                <input
                                  className='smart-discount-input'
                                  name='offers'
                                  value={option.checked ? option.given_discount : '0'}
                                  disabled={!option.edit || !option.checked}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (option.checked) {
                                      if (option.type === '7') {
                                        setSelectedOffer(option);
                                        setSelectedRangeId(option.selected_range_id || null);
                                        setDrawerOpen(true);
                                      } else {
                                        setSelectedGenericOffer(option);
                                        setGenericInputValue(option.given_discount || '');
                                        setGenericDialogOpen(true);
                                      }
                                    }
                                  }}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                          <div className='oficbs' style={{justifyContent:'space-between'}}>
                            <div className='dbpats' style={{flex:1}}>
                              <p style={{textTransform:'uppercase'}}>{option.title}</p>
                            </div>
                            <div className='dbcb' style={{flex:'none'}} onClick={(e) => e.stopPropagation()}>
                              <label className="smart-discount-toggle">
                                <input
                                  type="checkbox"
                                  checked={option.checked}
                                  onChange={() => handleCheckboxChange(option.id)}
                                />
                                <div className="slider round"></div>
                              </label>
                            </div>
                          </div>
                        </span>
                      </label>
                    </div>
                  ))
                ) : (
                  <p>No offer available</p>
                )}
              </div>
            </div>

            <div className='clp-footer' style={{borderTop:'1px solid rgba(0,0,0,0.2)'}}>
              <a href={'/manage-discounts'} className='btn btn-blank' style={{alignContent:'center'}}>Cancel</a>
              <button className='btn btn-black' onClick={saveListing}>Update</button>
            </div>

          </div>
          <div className='col-md-4 p-0'>
            <div className='bfhsd'>
                <div className='blog-box'>
                    <div class="blog">
                        <div class="blog-image">
                            <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                            <div class="date">May 08, 2025</div>
                        </div>
                        <div class="blog-content">
                            <h2>What is Lorem Ipsum?</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                            <a href="#">Read More</a>
                        </div>
                    </div>
                </div>
                <div className="faq-sticky">
                    {faqs.map((faq, index) => (
                    <div key={index} className='faqs-list-section'>
                        <div
                        onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                        style={{
                            backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                        }}
                        >
                        {faq.question}
                        <i
                            className={`fas ${
                            activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                            }`}
                            style={{
                            transition: "transform 0.3s ease",
                            }}
                        ></i>
                        </div>
                        {activeIndex === index && (
                        <div className='faqs-ans-box'>
                            {faq.answer}
                        </div>
                        )}
                    </div>
                    ))}
                </div>
            </div>
          </div>

        </div>

        <Dialog open={drawerOpen} onClose={() => setDrawerOpen(false)} fullWidth maxWidth="sm" PaperProps={{
            style: {
              margin: 0,
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            },
          }}>
          <DialogContent>
            <FormControl component="fieldset" className="w-100">
              <FormLabel component="legend" style={{ marginBottom: 10 }}>
                <img src={'/assets/img/icons/members_card_lcsi.webp'} className='img-fluid' />
              </FormLabel>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                {selectedOffer?.discount_range?.map((range) => {
                  const isSelected = selectedRangeId === range.id;
                  return (
                    <div
                      key={range.id}
                      onClick={() => {
                        const selectedId = range.id;
                        setSelectedRangeId(selectedId);

                        const selectedRange = selectedOffer.discount_range.find(
                          (r) => r.id === selectedId
                        );
                        if (selectedRange) {
                          setOfferList((prevOffers) =>
                            prevOffers.map((offer) =>
                              offer.id === selectedOffer.id
                                ? {
                                    ...offer,
                                    given_discount: selectedRange.re,
                                    selected_range_id: selectedId,
                                  }
                                : offer
                            )
                          );
                        }
                      }}
                      style={{
                        width: 'calc(50% - 6px)',
                        borderRadius: '0px',
                        border: `2px solid ${isSelected ? '#00aa55' : '#ccc'}`,
                        backgroundColor: isSelected ? '#e6fff3' : '#fff',
                        cursor: 'pointer',
                        textAlign: 'center',
                        fontWeight: isSelected ? '600' : '600',
                        transition: 'all 0.2s ease-in-out',
                        fontSize: '20px',
                        fontFamily: 'DejaVu',
                        textTransform: 'uppercase',
                      }}
                    >
                      {range.img ? (
                        <img src={range.img} className='img-fluid' alt='' />
                      ) : (
                        <>{range.title}</>
                      )}
                    </div>
                  );
                })}
              </div>
            </FormControl>
          </DialogContent>
          <DialogActions style={{ padding: '16px 24px' }}>
            <div style={{ display: 'flex', width: '100%', gap: '10px', }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setDrawerOpen(false)}
                style={{ width: '50%', height: '50px', borderRadius: '0', fontFamily: 'DejaVu',}}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={() => setDrawerOpen(false)}
                style={{ width: '50%', height: '50px', borderRadius: '0', fontFamily: 'DejaVu',}}
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </Dialog>

        <Dialog open={genericDialogOpen} onClose={() => setGenericDialogOpen(false)} fullWidth maxWidth="sm" PaperProps={{
          style: {
            margin: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          },
        }}>
          <DialogContent>
            <div className='mb-2'>
              <img src={offerImage} alt='' className='img-fluid' />
            </div>
            <FormLabel component="legend" style={{fontWeight:'600', textTransform:'uppercase'}}>{genericOfferText}</FormLabel>
            <input
              type="text"
              value={genericInputValue}
              onChange={(e) => setGenericInputValue(e.target.value)}
              className="form-control smart-discount-input w-100"
              placeholder="Enter discount"
            />
          </DialogContent>
          <DialogActions style={{ padding: '16px 24px' }}>
            <div style={{ display: 'flex', width: '100%', gap: '10px', }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setGenericDialogOpen(false);
                  setGenericInputValue('');
                }}
                style={{ width: '50%', height: '50px', borderRadius: '0', fontFamily: 'DejaVu',}}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  if (selectedGenericOffer) {
                    setOfferList((prev) =>
                      prev.map((offer) =>
                        offer.id === selectedGenericOffer.id
                          ? { ...offer, given_discount: genericInputValue }
                          : offer
                      )
                    );
                  }
                  setGenericDialogOpen(false);
                }}
                style={{ width: '50%', height: '50px', borderRadius: '0', fontFamily: 'DejaVu',}}
              >
                Save
              </Button>
            </div>
          </DialogActions>
        </Dialog>

      </div>
    </>
  );
};

export default SmartDiscounts;
